import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    mainButton: {
      borderColor: palette.blue,
      color: palette.blue,
      height: 32,
      padding: '5px 8px',

      '& .MuiButton-startIcon': { marginRight: 6 },
    },
    dynamicButtonText: {
      color: palette.blue,
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    cleanButton: {
      color: palette.red,
      height: 32,
      padding: '0px 14px',
      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
    applyButton: {
      color: palette.green,
      padding: '0px 14px',
      marginBottom: 16,
      height: 40,
    },
    filterCount: {
      color: palette.white,
      backgroundColor: palette.blue,
      borderRadius: '50%',
      width: 16,
      minWidth: 16,
      height: 16,
      marginLeft: 8,
      alignItems: 'center',
      display: 'grid',
      fontSize: 10,
    },
    container: {
      alignItems: 'center',
      '& .MuiButton-endIcon': { marginLeft: 2 },
      '& .MuiOutlinedInput-root': { height: 40 },
      '& .MuiInputLabel-animated': {
        transform: 'translate(14px, 15px) scale(1)',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '70%',
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(14px, -4px) scale(0.75)',
        color: palette.blue,
        fontWeight: 600,
      },
    },
    iconCheck: { color: palette.green, fontSize: 15, marginRight: 10 },
    iconRemoveAll: { color: palette.red, fontSize: 15, marginRight: 10 },
    textFieldGrid: {
      marginRight: 7,
      '& .MuiSelect-outlined.MuiSelect-outlined': { width: 170 },
      '& .MuiSelect-iconOutlined': { padding: '0px 20px' },
    },
    textField: {
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.blue,
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: palette.blue,
      },
    },
    closeIcon: { color: palette.red, fontSize: 15, cursor: 'pointer' },
    cleanIcon: { color: palette.red, fontSize: 26, cursor: 'pointer' },
    applyIcon: { color: palette.green, fontSize: 26, cursor: 'pointer' },
    divider: {
      borderBottom: `1px solid ${palette.divider}`,
      height: 1,
    },
    item: { marginBottom: 16 },
    search: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      padding: '5px 0px',
      margin: '16px 8px 16px 0px',
      maxWidth: '100%',
    },
    searchIcon: {
      color: palette.gray,
      margin: '0px 12px',
      opacity: 0.5,
      fontSize: 20,
    },
    searchInput: {
      width: '100%',
      fontSize: 14,
      color: palette.darkGray,
      '& .MuiInputBase-input': { padding: 0 },
    },
    searchBar: { width: 'calc(100% - 400px)' },
    searchBarNoExport: { width: 'calc(100% - 360px)' },
    searchBarNoSwitch: { width: 'calc(100% - 265px)' },
    mainButtonSize: { width: '10%' },
    searchButtonSize: { margin: 0 },
    listButtonSize: { marginRight: 0 },
    listAll: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    switch: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      display: 'flex',
      width: '15%',
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '11px',
      },
    },
    searchContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      [breakpoints.down('sm')]: {
        display: 'flex',
      },
    },
    filterIcon: { color: palette.blue, fontSize: 18, cursor: 'pointer' },
    filterGrid: {
      height: 32,
      alignItems: 'center',
      display: 'flex',
      marginRight: 8,
      marginBottom: 8,
    },
    selectAll: {
      color: palette.green,
    },
    removeAll: {
      color: palette.red,
    },
    selectAllButton: {
      '&:hover': {
        backgroundColor: palette.superLightGreen,
      },
    },
    removeAllButton: {
      '&:hover': {
        backgroundColor: palette.superLightRed,
      },
    },
    displayFlex: { display: 'flex', alignItems: 'center' },
    filterOptions: { marginBottom: 8 },
    optionSelected: {
      fontSize: 11,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    buttonsGrid: {
      justifyContent: 'space-between',
      display: 'flex',
      width: 360,
    },
    buttonsGridWithAction: {
      justifyContent: 'space-between',
      display: 'flex',
      width: 400,
    },
    buttonsGridNoSwitchList: {
      justifyContent: 'space-between',
      display: 'flex',
      width: 265,
    },
  });
